import React from 'react';
import { withTheme } from 'styled-components';
import { get } from 'lodash';
import Flex from 'core/components/Flex';
import Box from 'core/components/Box';
import Text from 'core/components/Text';
import Tooltip from 'core/components/Tooltip';
import {
  ALERT_SEVERITY_COLORS,
  ALERT_MANAGER_SEVERITY_TO_STANDARD_ALERT_SEVERITY,
  SEVERITY_KEY_OVERRIDES,
  ALERT_SEVERITY_RANKS,
  ALERT_SEVERITY_LABELS
} from '@kentik/ui-shared/alerting/constants';

const Bar = ({ bg, small }) => (
  <Box bg={bg} width={small ? '3px' : '5px'} height={small ? '12px' : '18px'} borderRadius={small ? '1px' : '2px'} />
);

const AlertSeverityBars = ({
  theme,
  severity,
  showLabel = false,
  showTooltip = false,
  disabled = false,
  small = false,
  labelProps = {},
  wrapperProps = {}
}) => {
  if (!severity) {
    return null;
  }

  // Severity-based lookups
  const severityKey =
    ALERT_MANAGER_SEVERITY_TO_STANDARD_ALERT_SEVERITY[severity] ||
    SEVERITY_KEY_OVERRIDES[severity.toLowerCase()] ||
    severity.toLowerCase();
  const severityColor = ALERT_SEVERITY_COLORS[severityKey];
  const severityLabel = ALERT_SEVERITY_LABELS[severityKey];
  const barsToFill = ALERT_SEVERITY_RANKS[severityKey];

  // Color settings
  const modeColor = theme.name === 'dark' ? 'white' : 'black';
  const emptyFillColor = theme.colors[modeColor][1];
  const disabledFillColor = theme.colors[modeColor][3];
  const barFillColor = disabled ? disabledFillColor : get(theme.colors, severityColor);

  // Generate the bar colors
  const barColors = Array.from({ length: 5 }).fill(emptyFillColor).fill(barFillColor, 0, barsToFill);

  const barsComponent = (
    <Flex gap={small ? '1px' : '2px'}>
      {barColors.map((color, idx) => (
        // eslint-disable-next-line react/no-array-index-key
        <Bar key={idx} bg={color} small={small} />
      ))}
    </Flex>
  );

  return (
    <Flex alignItems="center" gap={small ? '6px' : '8px'} {...wrapperProps}>
      {/* lineHeight={0} prevents Tooltip's .bp4-popover-target wrapper from affecting vertical alignment */}
      <Box lineHeight={0}>
        <Tooltip content={showTooltip ? severityLabel : undefined}>{barsComponent}</Tooltip>
      </Box>
      {showLabel && (
        <Text
          as="div"
          fontWeight="bold"
          small={small}
          muted={disabled}
          fontSize={small ? '12px' : '14px'}
          {...labelProps}
        >
          {severityLabel}
        </Text>
      )}
    </Flex>
  );
};

export default withTheme(AlertSeverityBars);
